export default __webpack_public_path__ + "static/media/blue-light.c8eb6b4f.svg";